import { useContext } from 'react'
import PropTypes from 'prop-types'
import { MarkupContext } from '../../providers/Markup'

const Loader = ({ size = 'default' }) => {
  const { detectPaletteClass } = useContext(MarkupContext)
  return (
    <span
      data-type="loader"
      data-size={size === 'default' ? undefined : size}
      className={detectPaletteClass('after:border-(--nds-primary-blue) secondary-500 before:border-(--sb-secondary-bg)')}
    />
  )
}

Loader.propTypes = {
  // 'sm' renders a compact spinner for inline use (e.g. next to status text);
  // 'default' is the full-size block spinner used while page/form content loads.
  size: PropTypes.oneOf(['default', 'sm']),
}

export default Loader
